import React, { useState } from 'react';
import { Table, Button, Badge, Row, Col, 
    // Dropdown, DropdownToggle, DropdownMenu, DropdownItem 
} from 'reactstrap';
import { MultiSelect } from "react-multi-select-component";
// import classnames from 'classnames';
import './../Components.css';

export default function Purchase(props) {
    //start of dropdown realated states and function
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdowntoggle = () => setDropdownOpen(prevState => !prevState);
    const dropdownHandler = (item) => {

    }

    //start of react-multi-select-component states and ...
    const options = [
        { label: "Chrono24 - Direkteinkauf", value: "Chrono24 - Direkteinkauf" },
        { label: "Chrono24 - Neuzugänge", value: "Chrono24 - Neuzugänge" },
        { label: "Chrono24 - Marinas Liste", value: "Chrono24 - Marinas Liste" },
        { label: "EbayKomfort - Direkteinkauf", value: "EbayKomfort - Direkteinkauf" },
        { label: "WebShop - Direkteinkauf", value: "WebShop - Direkteinkauf" }
    ];

    const [selected, setSelected] = useState([]);
    //end of react-multi-select-component states and ...

    const handleClick = () => {

    }

    return (
        <div className="container customContainer" >
            <Badge className="mb-4 h3" variant="info"><h1 className="h3">Purchase</h1></Badge>
            <div className="headlineOfPurchase">

                <div style={{ display: "flex" }}>
                    <p className="mr-2 marginAuto">Filter</p>
                    <div className="mr-2" style={{ minWidth: "300px" }}>
                        {/* <pre>{JSON.stringify(selected)}</pre> */}
                        <MultiSelect
                            options={options}
                            value={selected}
                            onChange={setSelected}
                            labelledBy={"Select"}
                        />
                    </div>
                </div>
                <select className="form-control" style={{maxWidth:'150px', minWidth: '150px'}} aria-label="Default select example">
                        <option selected>Status</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                    </select>
                <div className="dropdown" style={{display: 'flex', alignItems: 'baseline'}}>
                    <label className="mr-2">Sortierung: </label>
                    <select className="form-control" style={{maxWidth:'150px', minWidth: '150px'}} aria-label="Default select example">
                        <option selected>Neu gelistet</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                    </select>
                </div>
                <Button color="primary">Aktualisieren</Button>
            </div>
            <hr></hr>
            <Row>
                <Col sm="12">
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p><strong>86</strong> Ergenbnisse</p>
                        </div>
                        <Table striped bordered hover>
                            {/* <thead>
                                <tr>
                                    <th>Interne Nummer</th>
                                    <th>Auftragsnummer</th>
                                    <th>Channel</th>
                                    <th>To details</th>
                                </tr>
                            </thead> */}
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="mb-4" style={{ display: "flex" }}>
                                            <img className="mr-4" src="https://pics.zeitauktion.com/2021/2103602_04_small.jpg" alt="Uhr img" />
                                            <div style={{ flexDirection: "column" }}>
                                                <div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <h4>Rolex Submariener</h4>
                                                        <p>Listing ID: 19920783</p>
                                                    </div>
                                                    <h5>Verkäufer: <span>Max Mustermann, eutschland (muster.max@gmail.com)</span></h5>
                                                </div>
                                                <div style={{ display: "flex" }}>
                                                    <div>
                                                        <tbody>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Gehäusematerial</b></td>
                                                                <td>Steel</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Datum</b></td>
                                                                <td>23/6/21 9:59</td>
                                                            </tr>
                                                        </tbody>
                                                        <h4 className="mt-4">Listing-Preis: <strong>4770 EUR,-</strong></h4>
                                                    </div>
                                                    <div className="vl"></div>
                                                    <div>
                                                        <tbody>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Gehäusematerial</b></td>
                                                                <td>Steel</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Datum</b></td>
                                                                <td>23/6/21 9:59</td>
                                                            </tr>
                                                        </tbody>
                                                        <h4 className="mt-4">Preisangebot: <strong>4770 EUR,-</strong></h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <h5>Status: Ungeprüft</h5>
                                        <div>
                                            <div style={{ display: ' inline-flex', flexDirection: 'column' }}>
                                                <Button color='warning' className="mb-2">Annehmen</Button>
                                                <Button className="mb-2">Ablehnen</Button>
                                                <Button className="mb-2" style={{ display: 'none' }}>Löschen</Button>
                                            </div>
                                            <input className="ml-2" placeholder="Bitte Preisvorschlag eingeben"></input> EUR,-
                                        </div>
                                        <div className="mt-5" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                            <textarea className="mb-2" style={{ height: '150px' }} placeholder="Kommentar eingeben."></textarea>
                                            <Button color='primary'>Kommentar speichern</Button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: '75%' }}>
                                        <div className="mb-4" style={{ display: "flex" }}>
                                            <img style={{ objectFit: 'contain' }} className="mr-4" src="https://pics.zeitauktion.com/2021/2103602_04_small.jpg" alt="Uhr img" />
                                            <div style={{ flexDirection: "column" }}>
                                                <div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <h4>Rolex Submariener</h4>
                                                        <p>Listing ID: 19920783</p>
                                                    </div>
                                                    <h5>Verkäufer: <span>Max Mustermann, eutschland (muster.max@gmail.com)</span></h5>
                                                </div>
                                                <div style={{ display: "flex", justifyContent: 'flex-start' }}>
                                                    <div>
                                                        <tbody>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono24 = Marinas Liste</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Gehäusematerial</b></td>
                                                                <td>Steel</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Datum</b></td>
                                                                <td>23/6/21 9:59</td>
                                                            </tr>
                                                        </tbody>
                                                        <h4 className="mt-4">Listing-Preis: <strong>Nein</strong></h4>
                                                    </div>
                                                    <div className="vl"></div>
                                                    <div>
                                                        <tbody>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Kanal</b></td>
                                                                <td>Chrono</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Gehäusematerial</b></td>
                                                                <td>Steel</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Email</b></td>
                                                                <td>muster.max@gmail.com</td>
                                                            </tr>
                                                        </tbody>
                                                        <h4 className="mt-4">Preisangebot: <strong>8900 EUR,-</strong></h4>
                                                    </div>
                                                </div>
                                                <table>
                                                    <div className="extraInfo">
                                                        <hr></hr>
                                                        <h5>Weitere Information</h5>
                                                        <tbody>
                                                            <tr>
                                                                <td>Verkäufer-Kommentar</td>
                                                                <td>
                                                                    <p>
                                                                        dfsafsdgieorgnengrtgnngtgnfoongewp g eirgrig er grgnen gerngerngqwkopfrengong e frtrtrtdfsafsdgieorgnengrtgnngtgnfoongewp g eirgrig er grgnen gerngerngqwkopfrengong e frtrtrt gerngqwkopfrengong e frtrtrtdfsafsdgieorgnengrtgnngtgnfoongewp g eirgrig er grgnen
                                                                        dfsafsdgieorgnengrtgnngtgnfoongewp g eirgrig er grgnen gerngerngqwkopfrengong e frtrtrtdfsafsdgieorgnengrtgnngtgnfoongewp g eirgrig er grgnen gerngerngqwkopfrengong e frtrtrtdfsafsdgieorgnengrtgnngtgnfoongewp g eirgrig er grgnen gerngerngqwkopfrengong e frtrtrt gerngqwkopfrengong e frtrtrtdfsafsdgieorgnengrtgnngtgnfoongewp g eirgrig er grgnen
                                                                        dfsafsdgieorgnengrtgnngtgnfoongewp g eirgrig er grgnen gerngerngqwkopfrengong e frtrtrt
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Foo Bar</td>
                                                                <td><a>Nov es ngles fact resultant europan es</a></td>
                                                            </tr>
                                                            <tr>
                                                                <td>Ipsum</td>
                                                                <td>2015</td>
                                                            </tr>
                                                        </tbody>
                                                    </div>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ width: '25%' }}>
                                        <h5>Status: Ungeprüft</h5>
                                        <div>
                                            <div style={{ display: ' inline-flex', flexDirection: 'column' }}>
                                                <Button color='warning' className="mb-2">Annehmen</Button>
                                                <Button className="mb-2">Ablehnen</Button>
                                            </div>
                                            <input className="ml-2" placeholder="Bitte Preisvorschlag eingeben"></input> EUR,-
                                        </div>
                                        <div className="mt-5" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                            <textarea className="mb-2" style={{ height: '150px' }} placeholder="Kommentar eingeben."></textarea>
                                            <Button color='primary'>Kommentar speichern</Button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
        </div>
    );
}
